export default {
  aigc_gptTranslator_title: 'GPT Translator',
  aigc_gptTranslator_game_type: '游戏类型',
  aigc_gptTranslator_input_plearhost: '键入或粘贴要翻译的文本',
  aigc_gptTranslator_translate: '翻译',
  aigc_gptTranslator_stop: '停止',
  aigc_gptTranslator_empty: '清空',
  aigc_gptTranslator_no_translate: '不知道该翻译什么?',
  aigc_gptTranslator_try_text: '试试我们的示例文本:',
  aigc_gptTranslator_demo_0: '{game_come}-{src}-{trg}-example',
  aigc_gptTranslator_demo_1: 'Genshine情报分析数据',
  aigc_gptTranslator_tips: '在"General"选项中，您看到的翻译是GPT4原生输出，未进行深度调优。仅供您体验与参考。',
  aigc_gptTranslator_copy_translation: '复制译文',

};